import { RailDefaults, railItemContent } from '@src/components/Rail/Rail.defaults'
import type {
  SKUSelectionRailItemProps,
  SKUSelectionRailProps,
} from '@src/components/SKUSelectionRail/SKUSelectionRail.props'

const { items, ...railDefaults } = RailDefaults

export const defaultSKUSelectionRailItem: SKUSelectionRailItemProps = {
  blocks: [railItemContent] as any,
  sku: 'BBUSBBP1004',
  imageAlt: 'Energize Lemon',
  imageUrl:
    'https://res.cloudinary.com/teambeachbody/image/upload/v1721769752/BODi-Merchandising/Energize%20PDP/bbp-enrgize-lemon-40-pdp-1324-1324-en-us-071224.jpg',
}
const defaultSKUSelectionRailItem2: SKUSelectionRailItemProps = {
  blocks: [railItemContent] as any,
  sku: 'BBUSBBPTUB201',
  imageAlt: 'Energize Strawberry Lemonage',
  imageUrl:
    'https://res.cloudinary.com/teambeachbody/image/upload/v1721769746/BODi-Merchandising/Energize%20PDP/bbp-enrgize-ezsl-40-pdp-1324-1324-en-us-071224.jpg',
}

const defaultSKUSelectionRailItem3: SKUSelectionRailItemProps = {
  blocks: [railItemContent] as any,
  sku: 'BBSHKUSPCK105',
  imageAlt: 'Shakeology',
  imageUrl:
    'https://res.cloudinary.com/teambeachbody/image/upload/v1724697801/BODi-Merchandising/Shakeology%20Whey/shk-choc-why-14-pdp-1324-1324-en-us-082324.jpg',
}

export const SKUSelectionRailDefaults: SKUSelectionRailProps = {
  railProps: railDefaults,
  items: [defaultSKUSelectionRailItem, defaultSKUSelectionRailItem2, defaultSKUSelectionRailItem3],
  maxSelection: 1,
  minSelection: 1,
}
